<button
    type="button"
    class="spot-link wp-table--columns-selection"
    [title]="text.configureTable"
    (click)="openTableConfigurationModal()"
>
  <op-icon icon-classes="icon-button icon-small icon-no-color icon-settings" />
</button>
